/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReCAPTCHAComponent from "./GoogelRecaptcha/googleCaptcha";
import { MdOutlinePhoneCallback, MdPhoneAndroid, MdMail } from "react-icons/md";
import { AiOutlineMail } from "react-icons/ai";
import apiendpoints from "../apiendpoints.json";
import { motion } from "framer-motion";
import Thanku from "./HomePageComp/Thanku";

function ReachUs() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("Equity Research Mart - Enquiry");
  const [body, setBody] = useState("");
  const [phone, setPhone] = useState("");
  const [state, setstate] = useState("");
  const [country, setcountry] = useState("");
  const [city, setcity] = useState("");
  const [isCaptchaValid, setisCaptchaValid] = useState(false);
  const [buttonEnable, setButton] = useState(true);
  const [showThank, setThank] = useState(false);
  const handleCaptchaChange = (value) => {
    setisCaptchaValid(!!value);
  };
  // const handlethanku=()=>{
  //   setThank(!showThank)
  // }
  const handleSubmit = async (e) => {
    e.preventDefault();
    setButton(false);
    setisCaptchaValid(false);

    const formData = {
      email: email,
      subject: subject,
      message: body,
      State: state,
      Country: country,
      City: city,
      mobile: phone,
      nameUser: name,
      entity: "equity",
    };

    try {
      if (window.gtag) {
        window.gtag("event", "conversion", {
          send_to: "AW-11496349823/wuRHCO7it_cZEP_A8ekq", // Replace with your Conversion ID and Label
        });
        console.log("Google Ads Conversion triggered");
      } else {
        console.warn("gtag is not loaded yet");
      }
    } catch (error) {
      console.error("Error in gtag:", error);
    }

    try {
      const response = await fetch(apiendpoints.enquiryUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          entity: "equity",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Failed to send mail:", response.status, errorText);
        toast.error("Failed to send mail");
      }
      setButton(true);
      setisCaptchaValid(true);
      setThank(true);
      toast.success("Thanks for contacting us!");

      setEmail("");
      setSubject("Equity Research Mart - Enquiry");
      setBody("");
      setPhone("");
      setName("");
      setcountry("");
      setstate("");
      setcity("");
      //  setisCaptchaValid(false);
    } catch (error) {
      console.error("Error sending mail:", error);
      toast.error("Failed to send mail");
      setButton(true);
      setisCaptchaValid(true);
    }
  };

  return (
    <div>
      <section className=" h-auto ">
        <div className="container px-4 md:px-12 pb-24  mt-20 mx-auto">
          <div className="block rounded-lg px-6 py-12 md:py-16 md:px-12 -mt-[70px] backdrop-blur-[30px] ">
            <motion.div
              className="relative mb-8"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <h1 className="text-4xl lg:text-5xl text-gray-900 font-bold text-center mb-2">
                <span className="text-primary">Write </span>
                To{" "}
                <span className="underline underline-offset-8 decoration-[#2db928]">
                  Us
                </span>
              </h1>
            </motion.div>

            <p className="max-w-lg mb-4 md:px-6 lg:px-4 text-gray-800 xl:px-6 px-2 text-xl font-bold">
              Tell us about yourself
            </p>
            <div className="flex flex-col">
              <div className="mb-12 w-full md:px-3 lg:mb-0 lg:w-full lg:px-4">
                <form
                  onSubmit={handleSubmit}
                  className="mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2"
                >
                  
                  <div className="mb-4 max-w-md">
                    <label className="block text-gray-800 mb-2 text-sm font-semibold ">
                      Name
                      <input
                        type="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="shadow-sm bg-gray-200/70 border border-gray-300 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 mt-1 placeholder:italic placeholder:font-normal focus:outline-none text-black"
                        placeholder="Your name "
                        required
                      />
                    </label>
                  </div>
                  <div className="mb-4 max-w-md ">
                    <label className="block text-gray-800 mb-2 text-sm font-semibold ">
                      Email
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="shadow-sm bg-gray-200/70 border border-gray-300  text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 mt-1 placeholder:italic placeholder:font-normal text-black focus:outline-none"
                        placeholder="username@gmail.com"
                        required
                      />
                    </label>
                  </div>
                  <div className="mb-4 max-w-md">
                    <label className="block text-gray-800 mb-2 text-sm font-semibold">
                      Phone number
                      <input
                        type="tel"
                        value={phone}
                        onChange={(e) => {
                          const regex = /^[0-9]*$/;
                          const value = e.target?.value;
                          if (!regex.test(value)) {
                            // toast.error("Please Enter Numbers Only");
                            return;
                          } else if (value.length <= 10) {
                            setPhone(value); // update form data if valid
                            //console.log(value);
                          } else {
                            // toast.error("Please Enter a maximum of 10 digits");
                            return;
                          }
                        }}
                        className="shadow-sm bg-gray-200/70 border border-gray-300  text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 mt-1 placeholder:italic placeholder:font-normal text-black focus:outline-none"
                        placeholder="Your Phone number"
                        required
                      />
                    </label>
                  </div>
                  {/* <div className="mb-4 max-w-md">
                    <label className="block text-gray-800 mb-2 text-sm font-semibold ">
                      Country
                      <input
                        value={country}
                        onChange={(e) => setcountry(e.target.value)}
                        className="shadow-sm bg-gray-200/70 border border-gray-300  text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 mt-1 placeholder:italic placeholder:font-normal text-black focus:outline-none"
                        placeholder="Country"
                        required
                      />
                    </label>
                  </div> */}

                  <div className="mb-4 max-w-md">
                    <label className="block text-gray-800 mb-2 text-sm font-semibold ">
                      State
                      <input
                        value={state}
                        onChange={(e) => setstate(e.target.value)}
                        className="shadow-sm bg-gray-200/70 border border-gray-300  text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 mt-1 placeholder:italic placeholder:font-normal text-black focus:outline-none"
                        placeholder="State"
                        required
                      />
                    </label>
                  </div>

                  <div className="mb-4 max-w-md">
                    <label className="block text-gray-800 mb-2 text-sm font-semibold ">
                      City
                      <input
                        value={city}
                        onChange={(e) => setcity(e.target.value)}
                        className="shadow-sm bg-gray-200/70 border text-black border-gray-300 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 mt-1 placeholder:italic placeholder:font-normal focus:outline-none"
                        placeholder="City"
                        required
                      />
                    </label>
                  </div>
                  <div className="mb-4 max-w-md">
                    <label className="block mb-2 text-gray-800 text-sm font-semibold ">
                      Subject
                      <input
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        className="shadow-sm bg-gray-200/70 border border-gray-300  text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 mt-1 placeholder:italic placeholder:font-normal text-black focus:outline-none"
                        placeholder="Message"
                        required
                      />
                    </label>
                  </div>

                  <div className="mb-4 md:col-span-2 lg:col-span-3">
                    <label className="block mb-2 text-gray-800 text-sm font-semibold ">
                      Message
                      <textarea
                        value={body}
                        onChange={(e) => setBody(e.target.value)}
                        className="shadow-sm bg-gray-200/70 border border-gray-300  text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 mt-1 placeholder:italic placeholder:font-normal text-black focus:outline-none"
                        rows="6"
                        placeholder="Message"
                        required
                      ></textarea>
                    </label>
                  </div>

                  <div className="place-self-center md:col-span-2 lg:col-span-3">
                    <ReCAPTCHAComponent onChange={handleCaptchaChange} />
                  </div>

                  <button
                    type="submit"
                    className={`mb-6 w-full rounded text-white font-bold px-6 pt-2 pb-2 mt-3 text-lg  leading-normal lg:mb-0 max-w-sm md:col-span-2  lg:col-span-3  place-self-center ${
                      isCaptchaValid ? " bg-primary" : "bg-primary opacity-40"
                    }`}
                    disabled={!isCaptchaValid}
                  >
                    {buttonEnable ? "Send" : "Sending..."}
                  </button>
                </form>
              </div>

              <div class="font-sans max-w-7xl mx-auto p-4">
                <div class=" p-4 md:p-8">
                  <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 text-center">
                    <div class="flex flex-col items-center p-4 ">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-10 h-10 text-blue-600"
                        viewBox="0 0 473.806 473.806"
                      >
                        <path
                          d="M374.456 293.506c-9.7-10.1-21.4-15.5-33.8-15.5-12.3 0-24.1 5.3-34.2 15.4l-31.6 31.5c-2.6-1.4-5.2-2.7-7.7-4-3.6-1.8-7-3.5-9.9-5.3-29.6-18.8-56.5-43.3-82.3-75-12.5-15.8-20.9-29.1-27-42.6 8.2-7.5 15.8-15.3 23.2-22.8 2.8-2.8 5.6-5.7 8.4-8.5 21-21 21-48.2 0-69.2l-27.3-27.3c-3.1-3.1-6.3-6.3-9.3-9.5-6-6.2-12.3-12.6-18.8-18.6-9.7-9.6-21.3-14.7-33.5-14.7s-24 5.1-34 14.7l-.2.2-34 34.3c-12.8 12.8-20.1 28.4-21.7 46.5-2.4 29.2 6.2 56.4 12.8 74.2 16.2 43.7 40.4 84.2 76.5 127.6 43.8 52.3 96.5 93.6 156.7 122.7 23 10.9 53.7 23.8 88 26 2.1.1 4.3.2 6.3.2 23.1 0 42.5-8.3 57.7-24.8.1-.2.3-.3.4-.5 5.2-6.3 11.2-12 17.5-18.1 4.3-4.1 8.7-8.4 13-12.9 9.9-10.3 15.1-22.3 15.1-34.6 0-12.4-5.3-24.3-15.4-34.3l-54.9-55.1zm35.8 105.3c-.1 0-.1.1 0 0-3.9 4.2-7.9 8-12.2 12.2-6.5 6.2-13.1 12.7-19.3 20-10.1 10.8-22 15.9-37.6 15.9-1.5 0-3.1 0-4.6-.1-29.7-1.9-57.3-13.5-78-23.4-56.6-27.4-106.3-66.3-147.6-115.6-34.1-41.1-56.9-79.1-72-119.9-9.3-24.9-12.7-44.3-11.2-62.6 1-11.7 5.5-21.4 13.8-29.7l34.1-34.1c4.9-4.6 10.1-7.1 15.2-7.1 6.3 0 11.4 3.8 14.6 7l.3.3c6.1 5.7 11.9 11.6 18 17.9 3.1 3.2 6.3 6.4 9.5 9.7l27.3 27.3c10.6 10.6 10.6 20.4 0 31-2.9 2.9-5.7 5.8-8.6 8.6-8.4 8.6-16.4 16.6-25.1 24.4-.2.2-.4.3-.5.5-8.6 8.6-7 17-5.2 22.7l.3.9c7.1 17.2 17.1 33.4 32.3 52.7l.1.1c27.6 34 56.7 60.5 88.8 80.8 4.1 2.6 8.3 4.7 12.3 6.7 3.6 1.8 7 3.5 9.9 5.3.4.2.8.5 1.2.7 3.4 1.7 6.6 2.5 9.9 2.5 8.3 0 13.5-5.2 15.2-6.9l34.2-34.2c3.4-3.4 8.8-7.5 15.1-7.5 6.2 0 11.3 3.9 14.4 7.3l.2.2 55.1 55.1c10.3 10.2 10.3 20.7.1 31.3zm-154.2-286.1c26.2 4.4 50 16.8 69 35.8s31.3 42.8 35.8 69c1.1 6.6 6.8 11.2 13.3 11.2.8 0 1.5-.1 2.3-.2 7.4-1.2 12.3-8.2 11.1-15.6-5.4-31.7-20.4-60.6-43.3-83.5s-51.8-37.9-83.5-43.3c-7.4-1.2-14.3 3.7-15.6 11s3.5 14.4 10.9 15.6zm217.2 96.3c-8.9-52.2-33.5-99.7-71.3-137.5s-85.3-62.4-137.5-71.3c-7.3-1.3-14.2 3.7-15.5 11-1.2 7.4 3.7 14.3 11.1 15.6 46.6 7.9 89.1 30 122.9 63.7 33.8 33.8 55.8 76.3 63.7 122.9 1.1 6.6 6.8 11.2 13.3 11.2.8 0 1.5-.1 2.3-.2 7.3-1.1 12.3-8.1 11-15.4z"
                          data-original="#000000"
                        ></path>
                      </svg>
                      <h4 class="text-gray-800 text-lg font-semibold mt-4">
                        Call us
                      </h4>
                      <p class="text-sm text-gray-600 mt-1">+91 70044 93381</p>
                    </div>

                    <div class="flex flex-col items-center p-4 ">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-10 h-10 text-blue-600"
                        viewBox="0 0 32 32"
                      >
                        <path
                          d="M8 30a1.001 1.001 0 0 1-1-1v-5H4c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h24c1.654 0 3 1.346 3 3v16c0 1.654-1.346 3-3 3H15.851l-7.226 5.781A.998.998 0 0 1 8 30zM4 4c-.552 0-1 .449-1 1v16c0 .551.448 1 1 1h4a1 1 0 0 1 1 1v3.92l5.875-4.701A1 1 0 0 1 15.5 22H28c.552 0 1-.449 1-1V5c0-.551-.448-1-1-1z"
                          data-original="#000000"
                        ></path>
                      </svg>
                      <h4 class="text-gray-800 text-lg font-semibold mt-4">
                        Chat to us
                      </h4>
                      <p class="text-sm text-gray-600 mt-1">
                        info@equityresearchmart.in
                      </p>
                    </div>

                    <div class="flex flex-col items-center p-4 ">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-10 h-10 text-blue-600"
                        viewBox="0 0 100 100"
                      >
                        <path data-original="#000000"></path>
                      </svg>
                      <h4 class="text-gray-800 text-lg font-semibold mt-4">
                        Other
                      </h4>
                      <p class="text-sm text-gray-600 mt-1">
                        compliance@equityresearchmart.in
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr className="border-b-2 border-primary m-2" />

            <div className="flex justify-center bg-gradient-to-r from-cyan-200 to-green-400 p-2 rounded-md">
              <img src={"contact-us.svg"} alt="contact" className="h-56" />
            </div>
          </div>
        </div>
      </section>
      <ToastContainer
        autoClose={3000}
        limit={2}
        hideProgressBar={true}
        newestOnTop={true}
      ></ToastContainer>
      {showThank && (
        <div className="fixed h-screen inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-4 rounded shadow-lg">
            <Thanku />
          </div>
        </div>
      )}
    </div>
  );
}

export default ReachUs;
